import { useSelector } from "react-redux";
import { cameraShowDebugBoundarySelector } from "../redux/cameraSelectors";
import { Box } from "@react-three/drei";

export type DebugBoxProps = {
  center: XYZ;
  dimension: XYZ; // shouldn't be Point but they are literally same xP
  visible?: boolean;
  color?: string;
}

export const DebugBox = (props: DebugBoxProps) => {
  const { center, dimension, visible = false, color = 'blue' } = props;
  const showDebug = useSelector(cameraShowDebugBoundarySelector);
  if (visible === false && !showDebug) {
    return null;
  }

  return <Box position={center} args={dimension}>
    <meshStandardMaterial depthTest={false} attach='material' color={color} transparent opacity={0.1} />
  </Box>
}